import Octicon from '../components/Octicon.vue'

Octicon.register({"three-bars":{"width":12,"height":16,"d":"M11.41 9H.59C0 9 0 8.59 0 8c0-.59 0-1 .59-1H11.4c.59 0 .59.41.59 1 0 .59 0 1-.59 1h.01zm0-4H.59C0 5 0 4.59 0 4c0-.59 0-1 .59-1H11.4c.59 0 .59.41.59 1 0 .59 0 1-.59 1h.01zM.59 11H11.4c.59 0 .59.41.59 1 0 .59 0 1-.59 1H.59C0 13 0 12.59 0 12c0-.59 0-1 .59-1z"}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-octicon/icons/three-bars.js
// module id = h2/N
// module chunks = 0